import React from 'react';
import Link from 'gatsby-link';

import logo from '../../images/artiseq-logo.svg';
import styles from './header.module.css';

const Header = () => (
    <div className={styles.header}>
        <Link
            to='/'
        >
            <img src={logo} alt="Logo" />
        </Link>
    </div>
)

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js